import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Admission from '../Components/Admission';
import Success from '../Components/Success';

const AppRouter = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route index element={<Admission />} />
          <Route path='/success' element={<Success />} />
        </Routes>
      </Router>
    </div>
  )
}

export default AppRouter
